import React, { useLayoutEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useModalManager } from '../../../../../hooks/ModalManager.hook';

import BaseModalComponent from '../../../../../components/Modal/BaseModal.component';
import ButtonComponent, {
  StyledButton,
} from '../../../../../components/Button.component';
import TextareaComponent from '../../../../../components/Input/Textarea.component';
import {
  HR,
  HRJob,
} from '../../../../../redux/Dashboard/HRVacancies/HRVacancies.type';
import UserBadgeComponent from '../../../../../components/UserBadge.component';
import { textAriasMaxLength } from '../../../../../constants/textArias.constant';

interface Props extends React.AllHTMLAttributes<HTMLDivElement> {
  sectionItem: HR;
  selectedJob: HRJob;
  updateComment?: Function;
}

const VacancyCommentModalComponent = ({
  sectionItem,
  selectedJob,
  updateComment,
}: Props) => {
  const { t } = useTranslation();
  const { closeModal } = useModalManager();

  const [comment, setComment] = useState<string>('');

  useLayoutEffect(() => {
    if (sectionItem) {
      setComment(selectedJob.comment);
    }
  }, [sectionItem, selectedJob]);

  const handleCreateEdit = () => {
    updateComment &&
      updateComment({
        id: selectedJob.id,
        comment: comment,
      });
    closeModal();
  };

  const renderFooter = useMemo(
    () => (
      <StyledFooterButtonContainer>
        <StyledFooterButtonGroup>
          <ButtonComponent handleClick={handleCreateEdit} customColor="#206FE2">
            {t('Save')}
          </ButtonComponent>
          <ButtonComponent handleClick={closeModal}>
            {t('Cancel')}
          </ButtonComponent>
        </StyledFooterButtonGroup>
      </StyledFooterButtonContainer>
    ),

    [handleCreateEdit],
  );

  return (
    <BaseModalComponent
      header={t('Comment on the vacancy')}
      footer={renderFooter}
    >
      <StyledHRInfoWrapper>
        <div>{t(`controlModal.hr.Selected hr`)}:</div>
        <UserBadgeComponent info={sectionItem as any} />
      </StyledHRInfoWrapper>
      <StyledHRInfoWrapper>
        <div>{t('Selected vacancy')}:</div>
        <div>{selectedJob.job_name}</div>
      </StyledHRInfoWrapper>
      <TextareaComponent
        label={t('Comment')}
        value={comment}
        onChange={setComment}
        maxLength={textAriasMaxLength.EXTENDED}
      />
    </BaseModalComponent>
  );
};
export default VacancyCommentModalComponent;

export const StyledFooterButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 10px 0 0 0;
  gap: 10px;

  ${StyledButton} {
    min-width: 100px;
  }
`;

const StyledFooterButtonGroup = styled.div`
  display: flex;
  margin-left: auto;
  gap: 0.5rem;
`;

const StyledHRInfoWrapper = styled.div`
  display: flex;
  margin-bottom: 10px;
  > div:first-child {
    margin-right: 10px;
    font-weight: 500;
  }
`;
